//============================================================================
// Name        : SOInspectDialog.tsx
// Purpose     : Implement dialog for inspecting Sales Order
// Created     : 2019-09-24
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { IReduxReducers, ISaleOrder, ISOInspectDialog, ScheduleActions } from "./types";

const thead = css`
    & td {
        background-color: #2770a8;
        color: #ffffff;
        text-align: left;
    }
`;
const blueCell = css`
    background-color: #2770a8;
    color: #ffffff;
`;

class SOInspectDialog extends React.Component<ISOInspectDialog> {
    getClassName = () => this.props.show ? "modal show" : "modal fade";
    onClose = () => this.props.hide();
    parseServerDate = (serverDate: string): string => moment(serverDate).format("MM/DD/YYYY");
    formatDate = (date: string): string => moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");

    getSoForItem = (soId: number): ISaleOrder => this.props.inspectSO.sos.find(s => s.salesorder_id == soId);

    sumSoItemsQty = (soId: number): number =>
        this.props.inspectSO.inspectSO.filter(so => so.salesorder_id == soId)
            .reduce((accTotal, soItem) => accTotal + soItem.order_qty, 0)

    sumTotalSoItemsQty = (): number =>
        this.props.inspectSO.inspectSO.reduce((accTotal, so) => accTotal + so.order_qty, 0)
        // this.props.inspectSO.sos.reduce((accTotal, so) => accTotal + this.sumSoItemsQty(so.salesorder_id), 0)

    render() {
        return (
            <React.Fragment>
                <div className={this.getClassName()} tabIndex={-1} role="dialog">
                    <div className="modal-dialog" css={{ width: 1100 }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button onClick={this.onClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h1 className="modal-title">Inspect Sales Orders</h1>
                            </div>

                            <div className="modal-body">
                                <div className="table-responsive" css={{ maxHeight: 535 }}>
                                    <table className="table table-bordered table-striped">
                                        <thead css={thead}>
                                            <tr>
                                                <td>Expected SO<br/>Item Line Date</td>
                                                <td>Item Number</td>
                                                <td>Item Description</td>
                                                <td>SO #</td>
                                                <td>Customer Name</td>
                                                <td>UOM</td>
                                                <td>QTY</td>
                                                {/* <td>Cummulative QTY</td> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Loop through SOs */}
                                            {this.props.inspectSO.inspectSO.map((so, key) =>
                                                <tr key={key}>
                                                    <td>{this.parseServerDate(so.expected_shipment_date)}</td>
                                                    <td>{so.alu}</td>
                                                    <td>{so.item_description}</td>
                                                    <td>{so.salesorder_id}</td>
                                                    <td>{this.getSoForItem(so.salesorder_id).customer_name}</td>
                                                    <td>{so.measure_unit}</td>
                                                    {/* <td>{this.getSoForItem(so.salesorder_id).order_qty}</td> */}
                                                    <td>{so.order_qty}</td>
                                                    {/* <td>{this.sumSoItemsQty(so.salesorder_id)}</td> */}
                                                </tr>)}
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td css={blueCell}>Total</td>
                                                <td css={blueCell}></td>
                                                <td css={blueCell}>{this.sumTotalSoItemsQty()}</td>
                                                {/* <td css={blueCell}></td> */}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="modal-footer" css={{ padding: 15, marginTop: 0 }}>
                                <div css={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                    <div className="actions-footer">
                                        <button className="man-btn" onClick={this.onClose}>Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReduxReducers) => ({
    show:      state.schedule.showSOInspect,
    product:   state.schedule.product,
    inspectSO: state.schedule.inspectSO
});
const mapDispatchToProps = dispatch => ({
    hide: () => dispatch({
        type: ScheduleActions.HideSOInspectDialog
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(SOInspectDialog);
